import { Dialog } from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { usePrintRouteStore } from "~/stores/use-print-route-store";
import { Button } from "../ui/button";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import PrintRouteForm from "./print-route-form";

export default function PrintRouteDialog() {
  const {
    selectedPrintRoute,
    printRouteDialogOpen,
    setPrintRouteDialogOpen,
    setSelectedPrintRoute,
  } = usePrintRouteStore();

  const { t } = useTranslation("common");
  const { checkUnsavedChanges } = useUnsavedChanges();
  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedPrintRoute(undefined);
    }
    setPrintRouteDialogOpen(open);
  };
  return (
    <Dialog open={printRouteDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("PrintRoute.print_route")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <PrintRouteForm
            printRoute={selectedPrintRoute}
            onClose={(force) => handleDialog(false, force)}
          />
        </div>
        <DialogFooter>
          <Button
            type="submit"
            form="print-route-form"
            className="w-full"
            variant="success"
          >
            {selectedPrintRoute?.id ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
